/*
* Name of constant variables are defined here
* */

export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const USER_INFO = "USER_INFO";
export const BOOKMARK = "BOOKMARK";

